<template>
  <v-expansion-panel>
    <v-expansion-panel-header>Maps</v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row>
        <v-col cols="12" style="justify-items: flex-end;">
          <v-switch
              v-model="model.mapsExclude"
              hide-details
              color="orange darken-3"
              label="Exclude mode"
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col
          v-for="map in maps"
          :key="`ikm${map}`"
          cols="12"
          md="2"
          sm="2"
        >
          <v-checkbox
            v-model="model.maps"
            :value="map"
            :label="`${map}`"
          />
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export default {
  name: "r-maps-panel",
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      maps: RedactorUtils.getMapKinds()
        .map(m => m.code)
        .sort((a, b) => a - b)
    };
  }
};
</script>
